import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import productReducer from "./slices/productSlice";
import orderReducer from "./slices/orderSlice";
import cartReducer from "./slices/cartSlice";
import walletReducer from "./slices/walletSlice";
import uiReducer from "./slices/uiSlice";
import checkoutReducer from "./slices/checkoutSlice";
import adminReturnsReducer from "./slices/returnsAdminSlice";
import userReturnsReducer from "./slices/returnsUserSlice";
import couponReducer from "./slices/couponSlice";
import couponUsageReducer from "./slices/couponUsageSlice";
import shippingReducer from "./slices/shippingSlice";
import adminShippingReducer from "./slices/adminShippingSlice";
import taxReducer from "./slices/taxSlice";

/**
 * Redux store configuration with all reducers
 */
const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    products: productReducer,
    orders: orderReducer,
    cart: cartReducer,
    wallet: walletReducer,
    ui: uiReducer,
    checkout: checkoutReducer,
    adminReturns: adminReturnsReducer,
    userReturns: userReturnsReducer,
    coupons: couponReducer,
    couponUsages: couponUsageReducer,
    shipping: shippingReducer,
    adminShipping: adminShippingReducer,
    tax: taxReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types to allow non-serializable values
        ignoredActions: [
          "stripe/setInstance",
          "stripe/setElements",
          "stripe/setCardElement",
          "checkout/setCheckoutSession",
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: [
          "payload.stripe",
          "payload.elements",
          "payload.cardElement",
          "payload.checkoutSession",
          "meta.arg",
        ],
        // Ignore these paths in the state
        ignoredPaths: ["checkout.clientSecret", "checkout.checkoutSession"],
      },
      // Increase middleware timeouts for debugging
      immutableCheck: { warnAfter: 800 },
      serializableCheck: { warnAfter: 800 },
    }),
});

export default store;
